<template>
  <page-header-wrapper>
    <a-card :bordered="false" >
      <a-divider orientation="left">
        <b>LOGO管理</b>
      </a-divider>
      <a-form-model ref="form" :model="form" :rules="rules" >
<!--        <a-form-model-item label=" 是否预设一周logo ，0否1是" prop="isRegularTime" >-->
<!--          <a-input v-model="form.isRegularTime" placeholder="请输入 是否预设一周logo ，0否1是" />-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="logo图片地址" prop="imgUrl" >-->
<!--          <a-input v-model="form.imgUrl" placeholder="请输入logo图片地址" />-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="文字描述" prop="content" >-->
<!--          <a-input v-model="form.content" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="周一logo" prop="mondayImg" >
          <file-upload type="image" :defaultList="form.mondayImgArr" :count="1"
                       @input="getImg($event, 'mondayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周一文字" prop="mondayContent" >
          <a-input :maxLength="30" v-model="form.mondayContent" />
        </a-form-model-item>
        <a-form-model-item label="周二logo" prop="tuesdayImg" >
          <file-upload type="image" :defaultList="form.tuesdayImgArr" :count="1"
                       @input="getImg($event, 'tuesdayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周二文字" prop="tuesdayContent" >
          <a-input :maxLength="30" v-model="form.tuesdayContent" />
        </a-form-model-item>
        <a-form-model-item label="周三logo" prop="wednesdayImg" >
          <file-upload type="image" :defaultList="form.wednesdayImgArr" :count="1"
                       @input="getImg($event, 'wednesdayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周三文字" prop="wednesdayContent" >
          <a-input :maxLength="30" v-model="form.wednesdayContent" />
        </a-form-model-item>
        <a-form-model-item label="周四logo" prop="thursdayImg" >
          <file-upload type="image" :defaultList="form.thursdayImgArr" :count="1"
                       @input="getImg($event, 'thursdayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周四文字" prop="thursdayContent" >
          <a-input :maxLength="30" v-model="form.thursdayContent" />
        </a-form-model-item>
        <a-form-model-item label="周五logo" prop="fridayImg" >
          <file-upload type="image" :defaultList="form.fridayImgArr" :count="1"
                       @input="getImg($event, 'fridayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周五文字" prop="fridayContent" >
          <a-input :maxLength="30" v-model="form.fridayContent" />
        </a-form-model-item>
        <a-form-model-item label="周六logo" prop="saturdayImg" >
          <file-upload type="image" :defaultList="form.saturdayImgArr" :count="1"
                       @input="getImg($event, 'saturdayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周六文字" prop="saturdayContent" >
          <a-input :maxLength="30" v-model="form.saturdayContent" />
        </a-form-model-item>
        <a-form-model-item label="周日logo" prop="sundayImg" >
          <file-upload type="image" :defaultList="form.sundayImgArr" :count="1"
                       @input="getImg($event, 'sundayImg')"></file-upload>
          <span style="color: red">建议上传图片尺寸：32*67</span>
        </a-form-model-item>
        <a-form-model-item label="周日文字" prop="sundayContent" >
          <a-input :maxLength="30" v-model="form.sundayContent" />
        </a-form-model-item>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              保存
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {getLogo, updateLogo, addLogo} from '@/api/logo/logo'
import { tableMixin } from '@/store/table-mixin'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'Logo',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        isRegularTime: null,
        imgUrl: null,
        content: null,
        mondayImg: null,
        mondayImgArr: [],
        mondayImgCount: 1,
        mondayContent: null,
        tuesdayImg: null,
        tuesdayImgArr: [],
        tuesdayImgCount: 1,
        tuesdayContent: null,
        wednesdayImg: null,
        wednesdayImgArr: [],
        wednesdayImgCount: 1,
        wednesdayContent: null,
        thursdayImg: null,
        thursdayImgArr: [],
        thursdayImgCount: 1,
        thursdayContent: null,
        fridayImg: null,
        fridayImgArr: [],
        fridayImgCount: 1,
        fridayContent: null,
        saturdayImg: null,
        saturdayImgArr: [],
        saturdayImgCount: 1,
        saturdayContent: null,
        sundayImg: null,
        sundayImgArr: [],
        sundayImgCount: 1,
        sundayContent: null,
        createTime: null,
        remark: null,
      },
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
    this.init()
  },
  activated() {
    this.init()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init(){
      this.reset()
      getLogo().then(res=>{
        this.form = res.data
        let that =this
        this.form.mondayImgArr = []
        if(this.form.mondayImg){
          this.form.mondayImgArr.push({
            uid: guid(8, 10),
            name: that.form.mondayImg,
            status: 'done',
            halfUrl: that.form.mondayImg,
            url: that.form.mondayImg,
            path: that.form.mondayImg
          })
        }
        this.form.tuesdayImgArr = []
        if(this.form.tuesdayImg){
          this.form.tuesdayImgArr.push({
            uid: guid(8, 10),
            name: that.form.tuesdayImg,
            status: 'done',
            halfUrl: that.form.tuesdayImg,
            url: that.form.tuesdayImg,
            path: that.form.tuesdayImg
          })
        }
        this.form.wednesdayImgArr = []
        if(this.form.wednesdayImg){
          this.form.wednesdayImgArr.push({
            uid: guid(8, 10),
            name: that.form.wednesdayImg,
            status: 'done',
            halfUrl: that.form.wednesdayImg,
            url: that.form.wednesdayImg,
            path: that.form.wednesdayImg
          })
        }
        this.form.thursdayImgArr = []
        if(this.form.thursdayImg){
          this.form.thursdayImgArr.push({
            uid: guid(8, 10),
            name: that.form.thursdayImg,
            status: 'done',
            halfUrl: that.form.thursdayImg,
            url: that.form.thursdayImg,
            path: that.form.thursdayImg
          })
        }
        this.form.fridayImgArr = []
        if(this.form.fridayImg){
          this.form.fridayImgArr.push({
            uid: guid(8, 10),
            name: that.form.fridayImg,
            status: 'done',
            halfUrl: that.form.fridayImg,
            url: that.form.fridayImg,
            path: that.form.fridayImg
          })
        }
          this.form.saturdayImgArr = []
        if(this.form.saturdayImg){
          this.form.saturdayImgArr.push({
            uid: guid(8, 10),
            name: that.form.saturdayImg,
            status: 'done',
            halfUrl: that.form.saturdayImg,
            url: that.form.saturdayImg,
            path: that.form.saturdayImg
          })
        }
        this.form.sundayImgArr = []
        if(this.form.sundayImg){
          this.form.sundayImgArr.push({
            uid: guid(8, 10),
            name: that.form.sundayImg,
            status: 'done',
            halfUrl: that.form.sundayImg,
            url: that.form.sundayImg,
            path: that.form.sundayImg
          })
        }
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLogo(this.form).then(response => {
              this.$message.success(
                '操作成功',
                3
              )
              this.init()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLogo(this.form).then(response => {
              this.$message.success(
                '操作成功',
                3
              )
              this.init()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        isRegularTime: null,
        imgUrl: null,
        content: null,
        mondayImg: null,
        mondayImgArr: [],
        mondayImgCount: 1,
        mondayContent: null,
        tuesdayImg: null,
        tuesdayImgArr: [],
        tuesdayImgCount: 1,
        tuesdayContent: null,
        wednesdayImg: null,
        wednesdayImgArr: [],
        wednesdayImgCount: 1,
        wednesdayContent: null,
        thursdayImg: null,
        thursdayImgArr: [],
        thursdayImgCount: 1,
        thursdayContent: null,
        fridayImg: null,
        fridayImgArr: [],
        fridayImgCount: 1,
        fridayContent: null,
        saturdayImg: null,
        saturdayImgArr: [],
        saturdayImgCount: 1,
        saturdayContent: null,
        sundayImg: null,
        sundayImgArr: [],
        sundayImgCount: 1,
        sundayContent: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
  }
}
</script>
<style scoped>
  input{
  width: 1000px;
}
</style>
